module.exports = __webpack_public_path__ + "static/media/65.c2988ef8.jpg";